import React from 'react'
import PropTypes from 'prop-types'

export default function BrandPanel({
  logo,
  logoAlt = 'Asofix',
  title,
  titleStrong,
  description,
  fallbackMessage = 'No disponible en esta resolución'
}) {
  return (
    <div className="container-isotipo-white">
      <div className="logo-name">
        <img className="logo-img" src={logo} alt={logoAlt} />
      </div>
      <div className="subtitle-section">
        <div className="subtitle-name">
          <p className="brand-headline">
            {title}{' '}
            <b>{titleStrong}</b>
          </p>
          <span className="brand-rule" />
          <p className="brand-description">{description}</p>
        </div>
        <p className="subtitle-error">{fallbackMessage}</p>
      </div>
    </div>
  )
}

BrandPanel.propTypes = {
  logo: PropTypes.string,
  logoAlt: PropTypes.string,
  title: PropTypes.string,
  titleStrong: PropTypes.string,
  description: PropTypes.string,
  fallbackMessage: PropTypes.string
}
